import { useSelector } from 'react-redux';
import { EnrollmentStatus } from '@spike/payments-model';
import { useMarketplace, usePermissions } from 'hooks';
import { isPaymentsEnabled } from 'utils/MarketingUtils';
import { isNewAccount } from 'utils/PaymentsUtils';
import { RootState } from 'store';

export interface LeadDetailPermissions {
    canCreateSale: boolean;
    canSellMembership: boolean;
}

/**
 * Mirrors the sale gate `pages/Client.tsx` applies to its own New Sale button, so
 * the action is offered from Lead Detail under exactly the same conditions.
 */
export const useLeadDetailPermissions = (): LeadDetailPermissions => {
    const marketplace = useMarketplace();
    const permissions = usePermissions();
    const paymentsEnrollmentStatus = useSelector<RootState, EnrollmentStatus | undefined>(
        state => state.payments.enrollmentStatus
    );

    const featureFlag = process.env.REACT_APP_SINGLE_PAYMENT_ENABLED?.toLowerCase() === 'true';
    const paymentsCountryEnabled = isPaymentsEnabled(marketplace);
    const userHasPaymentsAccess = permissions.checkout.takePayments;
    const cuddlesPayReady = paymentsEnrollmentStatus
        ? isNewAccount(paymentsEnrollmentStatus)
            ? paymentsEnrollmentStatus.verificationStatus === 'valid'
            : paymentsEnrollmentStatus.enabled
        : false;

    return {
        canCreateSale: Boolean(featureFlag && paymentsCountryEnabled && userHasPaymentsAccess && cuddlesPayReady),
        canSellMembership: permissions.memberships.manage
    };
};
